import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
function CopyRights() {
  return (
    <section className="copyright-bar text-center">
      <Container fluid>
        <Row>
          <Col xs="12" className="py-3 align-self-center">
            <div className="smallfont spacegrotesk"> CopyRights &copy; @2024. Zentexus <span className='com'>.com</span> </div>
          </Col>
        </Row>
      </Container>
    </section>
  )

}
export default CopyRights;